import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { BASE_URL } from '../Config/Base';

const FoundSectionDifferentiatorsMain = () =>{

  useEffect(()=>{
    
    GetAddressOD();

    })

  function GetAddressOD(){

    fetch(`${BASE_URL}/Foundation/GetODTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
        //setAddress(data);
        // setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataOD", JSON.stringify(data));  
      }
      );
  
    }  

  return (

    <div className='foundation-addmain mainimage'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Differentiators</span>
    </div>
    </div>

    <div className='section-responsive'>
    <div className='foundation-section' id="section-menu" >

    <ul> 
    <li><Link to="/FoundSectionOD"><button className="foundation-sec-button" >Our Differentiators &nbsp;&nbsp;<i className="fa-solid fa-angles-right" /></button></Link></li>
    </ul>
    
    </div>
    </div>

    </div>
  )
}
export default FoundSectionDifferentiatorsMain
